import { createFileRoute } from "@tanstack/react-router";
import { TemplateGallery } from "@/features/consent-solutions";

const Route = createFileRoute("/_authorized/consent-solutions/$csId/popup/template-gallery/")({
  component: () => <TemplateGallery />,
});

export { Route };
